"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A proxy handler that prefixes all URLs with a given string.
 */

var ProxyHandlerStatic =
/*#__PURE__*/
function () {
  function ProxyHandlerStatic(prefixUrl) {
    _classCallCheck(this, ProxyHandlerStatic);

    this.prefixUrl = prefixUrl;
  }

  _createClass(ProxyHandlerStatic, [{
    key: "getProxy",
    value: function () {
      var _getProxy = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(request) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", {
                  init: request.init,
                  input: this.modifyInput(request.input)
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getProxy(_x) {
        return _getProxy.apply(this, arguments);
      }

      return getProxy;
    }()
  }, {
    key: "modifyInput",
    value: function modifyInput(input) {
      if (typeof input === 'string') {
        return this.prefixUrl + input;
      } else {
        return new Request(this.prefixUrl + input.url, input);
      }
    }
  }]);

  return ProxyHandlerStatic;
}();

exports.ProxyHandlerStatic = ProxyHandlerStatic;